import * as React from 'react'
import { observer } from 'mobx-react'
import { TextMessageContentViewModel } from './TextMessageContentViewModel'
import styles from './TextMessageContent.sass'

interface TextMessageContentProps {
  vm: TextMessageContentViewModel
  'data-test'?: string
}

/**
 " Text Message Content
 */
export default observer(function TextMessageContent({
  vm,
  'data-test': dataTest,
}: TextMessageContentProps) {
  return (
    <div
      data-private
      data-test={dataTest}
      className={styles.root}
      dangerouslySetInnerHTML={{
        __html: vm.htmlContent,
      }}
    />
  )
})
